$(document).ready(function () {
  
  var icc = document.getElementsByClassName("samping");
  var o;

  for (o = 0; o < icc.length; o++) {
    icc[o].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      panel.classList.toggle('panel-active')
    });
  }

  var acc = document.getElementsByClassName("desc-heading");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("panel-activated");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      } 
    });
  }

  document.querySelectorAll(".ColorSwatch__Radio-js").forEach(item => {
      item.addEventListener("change", () => {
        $('.swatch--add-to-cart').attr('data-var_id', item.value)
        $('.swatch--add-to-cart').attr('data-add-to-cart', item.value)
      })
  })

  $('.swatch--add-to-cart').click(function(){    
    var swatch_id = $(this).attr("data-var_id");
    swatchAddItemToCart( swatch_id, 1 );    // paste your id product number
    $('.cart_dr').trigger( "click" );
    // alert("Added to cart");
  });

  function swatchAddItemToCart(variant_id, qty) {
    data = {
      "id": variant_id,
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() {
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
  
        $('#sidebar-cart').attr('aria-hidden', 'false');
        $('.PageOverlay').addClass('is-visible');
        $('#sidebar-cart .Drawer__Close').click(function(){
          $('#sidebar-cart').attr('aria-hidden', 'true');
          $('.PageOverlay').removeClass('is-visible');
        })
  
      }  
      
    }); 
   
  }

})

/************************** button "add to cart" collection pages **************************/

$('.ad_to_cart_coll').click(function(){    
  var ID = $(this).attr("data-var_id");
  addItemToCart( ID, 1 );    // paste your id product number
  $('.cart_dr').trigger( "click" );
  // alert("Added to cart");
});


function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() {
      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      $('#sidebar-cart').attr('aria-hidden', 'false');
      $('.PageOverlay').addClass('is-visible');
      $('#sidebar-cart .Drawer__Close').click(function(){
        $('#sidebar-cart').attr('aria-hidden', 'true');
        $('.PageOverlay').removeClass('is-visible');
      })

    }  
    
  }); 
 
}